<template>
<div class="container container_signin">
    <div class="wrapper">
        <div class="container_signin--header">
            <img alt="" src="/static/images/logo_full.png"/>
        </div>
        <form class="form" validate v-on:submit.prevent="signin">
            <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>

            <div class="form--row">
                <label for="email">
                    <svg height="14" viewbox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#FFF" fill-rule="nonzero">
                            <path d="M15 0H1C.4 0 0 .4 0 1v1.4l8 4.5 8-4.4V1c0-.6-.4-1-1-1z">
                            </path>
                            <path d="M7.5 8.9L0 4.7V13c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V4.7L8.5 8.9c-.28.14-.72.14-1 0z">
                            </path>
                        </g>
                    </svg>
                </label>
                <fieldset class="form--item">
                    <div class="input_text">
                        <input id="email" name="" required v-model="user.email" placeholder="Email" type="email" value=""/>
                    </div>
                </fieldset>
            </div>
            <div class="form--row">
                <label for="password">
                    <svg height="16" viewbox="0 0 14 16" width="14" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 0C4.8 0 3 1.8 3 4v1H1c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1h-2V4c0-2.2-1.8-4-4-4zm1 11.7V13H6v-1.3c-.6-.3-1-1-1-1.7 0-1.1.9-2 2-2s2 .9 2 2c0 .7-.4 1.4-1 1.7zM9 5H5V4c0-1.1.9-2 2-2s2 .9 2 2v1z" fill="#FFF" fill-rule="nonzero">
                        </path>
                    </svg>
                </label>
                <fieldset class="form--item">
                    <div class="input_text">
                        <input id="password" name="" required v-model="user.password" placeholder="Password" type="password" value=""/>
                    </div>
                </fieldset>
            </div>
            <div class="button--wrapper">
                <button class="btn btn_white">
                    Sign In
                </button>
            </div>
        </form>
        <loading :visible.sync="loadingVisible"></loading>
    </div>
</div>
</template>
<script>
import * as HttpService from '../../services/http.service'
import * as AuthService from '../../services/auth.service'

import Message from '../Message.vue'
import Loading from '../Loading.vue'
export default {
  name: 'Signin',
  components: {Message, Loading},
  data () {
    return {
      user: {},
      errorMessage: '',
      loadingVisible: false
    }
  },
  methods: {
    signin() {
      var self =this;
      self.loadingVisible = true;
      HttpService.post('admin/users/login', self.user, function(res, error){
        if(error){
          self.errorMessage = error.message;
        }else{
          AuthService.login(res.result);
          self.$parent.is_logged_in = true;
          self.$router.push({name: 'Schedule'});
        }
        self.loadingVisible = false;
      });
    }
  }
  
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Signin.vue?1bef7238